import {Box, Container, Flex, Text} from '@chakra-ui/react'
import {createFileRoute} from '@tanstack/react-router'
import {useTranslate} from '@tolgee/react'

export const Route = createFileRoute('/auth/password-setup')({
  component: PasswordSetupPage,
})

function PasswordSetupPage() {
  const {t} = useTranslate('auth')

  return (
    <Container maxWidth="22rem" padding="0">
      <Flex flexDirection="column" gapY="1.5rem" textAlign="center">
        <Box>
          <Text as="h1" fontSize="2xl" fontWeight="bold" color="fg" fontFamily="heading">
            {t('password_setup_page_title')}
          </Text>
          <Text as="h2" fontSize="md" color="fg.muted">
            {t('password_setup_page_desc')}
          </Text>
        </Box>

        {/* <PasswordSetupForm /> */}
      </Flex>
    </Container>
  )
}
